import { useRoles } from '@nrx/auth-ui';
import { List, ListItemIcon, ListItemText } from '@nrx/ui';
import { TriangleAlert, type LucideIcon } from '@nrx/ui/icons';
import type { JSX } from 'react';

import { NavListItemButton } from './nav-list-item-button.js';
import { PORTAL_NAV_LINKS } from './portal-nav-config.js';

const PORTAL_LINK_ICONS: Record<string, LucideIcon> = {
  '/escalation-queue': TriangleAlert,
};

/**
 * Portal-wide sidebar navigation.
 *
 * Survey Builder now lives in the pantry suite (`apps/survey-builder`).
 * Marketing Outreach Upload now lives in `apps/marketing-outreach-upload`.
 */
export function PortalNav(): JSX.Element {
  const roles = useRoles();
  const visibleLinks = PORTAL_NAV_LINKS.filter((link) => link.isVisible(roles));

  return (
    <nav
      aria-label="Portal"
      className="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]"
    >
      <List>
        {visibleLinks.map((link) => {
          const Icon = PORTAL_LINK_ICONS[link.path];
          return (
            <NavListItemButton key={link.path} to={link.path}>
              {Icon ? (
                <ListItemIcon>
                  <Icon aria-hidden="true" size={20} />
                </ListItemIcon>
              ) : null}
              <ListItemText primary={link.label} />
            </NavListItemButton>
          );
        })}
      </List>
    </nav>
  );
}
